import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { AddressCheckerSelectComponent } from "src/app/modules/bootstrap/pms-ui/functions/address/address-checker/address-checker-select/address-checker-select.component";
import { AddressCheckerFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/address/address-checker/address-checker-function.service";
import { DxListModule } from "devextreme-angular";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { PipesModule } from "src/app/pipes/pipes.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    PipesModule,
    DxListModule,
    ButtonModule
  ],
  declarations: [AddressCheckerSelectComponent],
  providers: [AddressCheckerFunctionService]
})
export class AddressCheckerFunctionModule {}
